import React from "react";
import "./Container3.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ImageWithSkeleton from "../App/ImageWithSkeleton/ImageWithSkeleton";

const ContainerSet3 = () => {

    const categories = useSelector((state) => state.categories || []);
    console.log('categoriessssssssssssssssssssssssssssssss',categories[0].children[1].name)


    const navigate = useNavigate()

    const handleNaviate=(subid)=>{
      navigate(`/products/${subid}`)

   /*  console.log('sub iddddddddddddddddddddddddddddd',subid) */
    }
 

  const stacks = [
                {
                    title:categories[0].name,
                    category:[  { image: "/sub4.png", title:"Jwellery & Accessories","id":categories[0].children[0]?.id  },
                        { image: "/watch.jpg", title: "Accessories","id":categories[0].children[1]?.id },
                        { image: "/health.jpg", title: "Safety Accessories" ,"id":categories[0].children[2]?.id},
                        { image: "/jwellery.png", title: "Earrings","id":"JL00101" },]

                },
                {
                    title:categories[1].name,
                    category:[  { image: "/foot.png", title: "All Unisex Footwear","id":categories[1].children[0]?.id  },
                        { image: "/women.jpg", title: "Women","id":categories[1].children[1]?.id  },
                        { image: "/men.jpg", title: "Men","id":categories[1].children[2]?.id  },
                        { image: "/kids.jpg", title: "Kids","id":categories[1].children[3]?.id  },]

                },
                {
                    title:categories[2].name,
                    category:[  { image: "/homedecor.png", title: "All Home Decor","id":categories[2].children[0]?.id },
                        { image: "/showpiece.png", title: "Living Accessories","id":categories[2].children[1]?.id },
                        { image: "/home cleaning.jpg", title: "Home Cleaning","id":categories[2].children[2]?.id },
                        { image: "/kitchen.jpg", title: "Kitchen Storage","id":categories[2].children[3]?.id },]

                },
                {
                    title:categories[3].name,
                    category:[  { image: "/mobileac.jpg", title: "Mobile Accessories","id":categories[3].children[0]?.id  },
                        { image: "/comp.jpg", title: "Computers & Accessories","id":categories[3].children[1]?.id  },
                        { image: "/homeapp.jpg", title: "Home Electronics & Appliances","id":categories[3].children[2]?.id  },
                        { image: "/gadget.jpg", title: "Gadgets","id":categories[3].children[3]?.id  },]

                },
  ];



  const Container = styled.div`
  margin: 0 unset;
  width: max-content;
    overflow-x: scroll;
  gap:1rem;
  flex: 1;
  background-color: transparent;
  padding: unset !important;

  .set3contitem{
  background-color: #fff;
  padding:.4rem;
  margin: unset !important;

  }


  @media(max-width:851px){
  margin-left:unset;
  margin-right:unset;
  padding:1px
  }
  .container-set3-title{
  min-height:48px;
  }

 
  .container-set3-grid{
  
  grid-template-columns: repeat(2, 1fr) !important;
  gap:5px;
  }

  @media(max-width:601px){
  display: flex;
  gap:10px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  
  }
}

  @media (max-width: 601px) {
    display: flex !important;
    overflow-x: auto;
    flex-wrap: nowrap;
    gap: 1rem;
    padding-bottom: 8px;
 

 
  }

  .stack-card {
    min-width: 120px;
    flex: 0 0 auto;
  }

  @media (max-width: 601px) {
.container-set3{
max-width: 100vw;
}

  `



  return (
    <Container className="container-set3">
      {stacks.map((item) => {
        return (
          <div className="set3contitem"  >
            <h2 className="container-set3-title">{item.title}</h2>
            <div className="container-set3-grid">
              {item.category.map((stack, index) => (
                <div  onClick={()=>{handleNaviate(stack.id)}}  >

<StackCard key={index} stack={stack} />
                </div>
               
              ))}
            </div>
          </div>
        );
      })}
    </Container>
  );
};

// StackCard Component (Defined Inside)
const StackCard = ({ stack }) => {
  return (
    <div className="stack-card" style={{cursor:'pointer',padding:3}}>
    {/*   <img src={`/temp_images/${stack.image}`}  alt={stack.title} className="stack-card-image" style={{maxWidth:151,aspectRatio:1,objectFit:'cover',minWidth:57}} /> */}
      <ImageWithSkeleton  alt={stack.title}  src={`/temp_images/${stack.image}`}   />

      <h3 className="stack-card-title" style={{lineHeight:'1.1',minHeight:33}}>{stack.title}</h3>

  <style>
    {`
    .container-set3-title{
    line-height:1.2;

    }
    @media(max-width:851px){
      .stack-card-title {
        font-size: 0.8rem;
        min-height: 33px;
        
      }
      .container-set3-title{
    font-size: .95rem;
      }  
      }

      @media(max-width:601px){
  .stack-card{
     flex: 0 0 auto;
  }
    }
    `}
  </style>
    </div>
  );
};

export default ContainerSet3;
